import api from "../../../../../api"

class Reference_API
{
    constructor(self, group_id, id)
    {
        this.self = self
        this.group_id = group_id
        this.id = id
    }

    check_roles(roles)
    {
        return api.check_roles(this.self, roles)
    }

    get_reference_data()
    {
        return new Promise((resolve) => api.call(this, "cadastral_groups", "get", { id : this.group_id },
            ({ data }) => resolve(data.cost_evaluation_comparative.reference))
        )
    }

    set_field(key, value)
    {
        return api.call(this.self, "cadastral_cost_evaluation", "set_field",
            { "id" : this.id, "field" : "reference." + key, "value" : value },
            () => {
                api.show_notification(this.self, "Изменения сохранены")
            }
        )
    }

    get_statistics(attr)
    {
        // cadastral_groups / get_statistics

        // Параметры:
        //     id : ID расчета
        //     attr : ID

        return new Promise((resolve) => api.call(this.self, "cadastral_groups", "get_statistics",
            { id : this.group_id, attr : attr,
                // histogram_attr : upks_attr.id, with_median : true
            },
            response => resolve({ id : attr, ...response })
        ))
    }

    get_obj_by(field, value)
    {
        return new Promise((resolve) => api.call(this.self, "cadastral_objects", "get_by", { field, value }, ({ data }) => resolve(data)))
    }

    //#region Settings

    get_objects(params)
    {
        return new Promise((resolve) => api.call(this, "cadastral_objects", "get_many", params, ({ data: objects }) =>
            {
                resolve(objects)
            })
        )
    }

    calculate_deviation()
    {
        // cadastral_cost_evaluation / calculate_reference_deviation

        // Параметры:
            // id : ID расчета

        return api.call(this.self, "cadastral_cost_evaluation", "calculate_reference_deviation", { id : this.id }, () => {})
    }

    //#endregion

    //#region Sales

    set_correction(id, correction_id, value)
    {
        // cadastral_objects / set_field - ОО
        // cadastral_analogues / set_field - ОА

        // Параметры:
            // id : ID объекта
            // field = "system.reference_corrections.ID_ЦОФ"
            // value : float

        return api.call(this.self, "cadastral_analogues", "set_field", { id, field : `system.reference_corrections.${correction_id}`, value }, () => {})
    }

    add_correction({ attr_id, order, name })
    {
        const value = { "order" : order, "name" : attr_id ? attr_id : name }

        // cost_evaluation / add_to_array

        // id
        // arr = reference.corrections
        // value = { "order" : ORDER, "factor" : ID_FACTOR }

        return api.call(this.self, "cadastral_cost_evaluation", "add_to_array", { id : this.id, array : "reference.corrections", value }, () => {})
    }

    delete_correction({ attr_id, order, name })
    {
        const value = { "order" : order, "name" : attr_id ? attr_id : name }

        // cost_evaluation / delete_from_array

        // id
        // arr = reference.corrections
        // value = { "order" : ORDER, "factor" : ID_FACTOR }

        return api.call(this.self, "cadastral_cost_evaluation", "delete_from_array", { id : this.id, array : "reference.corrections", value }, () => {})
    }

    set_correction_many(attr_id, value)
    {
        // cadastral_objects / set_field_many - ОО
        // cadastral_analogues / set_field_many - ОА

        // Параметры:
            // field = "system.reference_corrections.ID_ЦОФ"
            // value : float
            // query

        return api.call(this.self, "cadastral_analogues", "set_field_many",
            { field : `system.reference_corrections.${attr_id}`, value }, () => {}
        )
    }

    unset_correction_many(attr_id)
    {
        // cadastral_objects / unset_field_many - ОО
        // cadastral_analogues / unset_field_many - ОА

        // Параметры:
        //     field = "system.reference_corrections.ID_ЦОФ"
        //     query

        const params = {
            field : `system.reference_corrections.${attr_id}`,
            query : JSON.stringify({ "and" : [
                { keys : [ "cadastral_group" ], operation : "cadastral_group", args : [ this.group_id ]},
            ]})
        }

        return api.call(this.self, "cadastral_analogues", "unset_field_many", params, () => {})
    }

    get_analogues_corrections(attrs)
    {
        // cadastral_cost_evaluation / calculate_reference_uprs_many

        // Параметры:
            // id : ID расчета
            // query (необязательный) - при запросе будет query AND ОА в группе

        return new Promise((resolve) => api.call(this.self,
            "cadastral_cost_evaluation",
            "calculate_reference_uprs_many",
            {
                id : this.id,
                query : JSON.stringify({
                    "and" : [
                        { "or" : [
                            { keys : [ 'current_version.attrs.analogue_profitable_type' ], operation : "eqs", args : [ 'Купля-продажа' ] },
                            { keys : [ 'current_version.attrs.analogue_profitable_type' ], operation : "eqs", args : [ 'Результат оценки рыночной стоимости' ] },
                        ]},
                        {
                            "and" : attrs.map((key) => ({ keys : [ "current_version." + key ], operation : "notempty", args : [] }))
                        }
                    ]
                })
            }, ({ data }) => { resolve(data) }
        ))
    }

    //#endregion
}

export default Reference_API
